document.addEventListener('DOMContentLoaded', function() {
  const sliderContainer = document.querySelector('.slider-container');
  const slider = document.querySelector('#Product-Slider');
  const slides = slider.querySelectorAll('.product-images__slide');
  const pagination = document.querySelector('#pagination');
  const bullets = pagination.querySelectorAll('li');
  const body = document.body;

  function updateActivePagination() {
    const offset = window.scrollY;
    const windowHeight = window.innerHeight;
    const padding = 0.75;
    const sliderBottom = sliderContainer.offsetTop + sliderContainer.offsetHeight;

    pagination.style.position = (offset + windowHeight >= sliderBottom) ? 'absolute' : 'fixed';

    slides.forEach((slide, index) => {
      const slideTop = slide.getBoundingClientRect().top + window.scrollY;
      if (offset > (slideTop - windowHeight * (1 - padding))) {
        bullets.forEach(bullet => bullet.classList.remove('active'));
        bullets[index].classList.add('active');
        body.className = `page-${index + 1}`;  // Fix with backticks
      }
    });
  }

  function updateMobilePagination() {
    const scrollLeft = slider.scrollLeft;
    const slideWidth = slides[0].offsetWidth;
    const index = Math.round(scrollLeft / slideWidth); // Closest slide index

    bullets.forEach(bullet => bullet.classList.remove('active'));
    if (bullets[index]) {
      bullets[index].classList.add('active');
      body.className = `page-${index + 1}`; // Fix with backticks
    }
  }

  if (window.innerWidth <= 480) {
    slider.addEventListener('scroll', updateMobilePagination);
  } else {
    window.addEventListener('scroll', updateActivePagination);
  }
  
  updateActivePagination(); // Initial load for desktop
  updateMobilePagination(); // Initial load for mobile

  // Smooth scrolling for pagination links
  bullets.forEach((bullet, index) => {
    bullet.addEventListener('click', function(e) {
      e.preventDefault();
      const targetSlide = slides[index]; // Direct reference to slide
      targetSlide.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      });
    });
  });
});
